import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const sellerReturnsSection = "/seller-returns/";

export const sellerReturnsListPath = sellerReturnsSection;
export const sellerReturnsListUrl = (params?: { status?: string }) =>
  sellerReturnsListPath + (params ? "?" + stringifyQs(params) : "");

export const sellerReturnPath = (id: string) =>
  urlJoin(sellerReturnsSection, id);
export const sellerReturnUrl = (id: string) =>
  sellerReturnPath(encodeURIComponent(id));
